// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dP_d_","colMin":"styles_colMin__1UvSs"};